module.exports = __webpack_public_path__ + "img/login_background-1.e95948bf.svg";